import type { InterviewSetup, SessionTranscriptBody } from './types';

/** A finished call whose transcript has not reached the server yet; kept so it can be resent. */
export interface PendingFinish {
  sessionId: string;
  setup: InterviewSetup;
  body: SessionTranscriptBody;
  savedAt: number;
}

export const PENDING_KEY = 'mock-interview:pending-finish:v1';

export function loadPending(): PendingFinish[] {
  try {
    const data: unknown = JSON.parse(window.localStorage.getItem(PENDING_KEY) ?? '[]');
    if (!Array.isArray(data)) return [];
    return data.filter(
      (item): item is PendingFinish =>
        Boolean(item) && typeof item === 'object' && typeof (item as PendingFinish).sessionId === 'string' && Boolean((item as PendingFinish).body),
    );
  } catch {
    return [];
  }
}

function write(list: PendingFinish[]): void {
  try {
    window.localStorage.setItem(PENDING_KEY, JSON.stringify(list.slice(0, 10)));
  } catch {
    // Best effort only.
  }
}

export function addPending(entry: PendingFinish): void {
  write([entry, ...loadPending().filter((item) => item.sessionId !== entry.sessionId)]);
}

export function removePending(sessionId: string): void {
  write(loadPending().filter((item) => item.sessionId !== sessionId));
}
